"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowMachine = void 0;
const workflow_1 = require("./workflow");
class WorkflowMachine {
    constructor(config, options) {
        this.options = options;
        this.workflow = config instanceof workflow_1.Workflow ? config : new workflow_1.Workflow(config);
        if (!options) {
            this.options = {};
        }
    }
    start(context) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = {
                path: this.workflow.stateNode.path,
                context: context || {}
            };
            return this.transition(state);
        });
    }
    canTransition(state, eventName) {
        state = Object.assign(Object.assign({}, state), { isSimulation: true }); // make a copy
        let stateNode = this.workflow.pathMap.get(state.path);
        if (!stateNode) {
            console.error(`Starting from beginning. State node not found for path: ${state.path}`);
            stateNode =
                (eventName && this.workflow.stateNode.findEvent(eventName, true)) ||
                    this.workflow.stateNode;
            console.error('starting from state node', stateNode.path);
        }
        // traverse children
        if (!eventName && stateNode.states && stateNode.states.length > 0) {
            const childStateNode = stateNode.states[0];
            state.path = childStateNode.path;
            return this.transition(state);
        }
        if (stateNode.events) {
            const events = stateNode.events.filter(event => 
            // process the specific transition or if not provided then perform transient events
            eventName ? event.name === eventName : event.isTransient);
            for (const event of events) {
                if (event.transitions.length > 0) {
                    // TODO: handle more than one transitions
                    const transition = event.transitions[0];
                    // check if transition conditions (guards) exists
                    if (transition.conditions) {
                        for (const condition of transition.conditions) {
                            // simulate guard (ignore promises)
                            const result = this.runGuardSync(state, condition);
                            if (typeof result === 'boolean' && !result) {
                                return false;
                            }
                        }
                    }
                    const destinationStateNode = this.workflow.getStateNodeRelativeTo(stateNode, transition.target);
                    if (destinationStateNode) {
                        return true;
                    }
                    else {
                        console.error(`Did not find destination state node for transition: ${transition.target}`);
                    }
                    break;
                }
            }
        }
        return state;
    }
    transition(state, eventName, transitionCount = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            state = Object.assign({}, state); // make a copy
            console.log(`transition(); state = ${state.path}; eventName: ${eventName}`);
            let stateNode = this.workflow.pathMap.get(state.path);
            if (!stateNode) {
                console.error(`Starting from beginning. State node not found for path: ${state.path}`);
                stateNode =
                    (eventName && this.workflow.stateNode.findEvent(eventName, true)) ||
                        this.workflow.stateNode;
                console.error('starting from state node', stateNode.path);
            }
            yield this.runAction(state, stateNode.onEntry);
            if (transitionCount !== 0) {
                // don't invoke when resuming a transition
                yield this.invokeService(state, stateNode.invoke);
            }
            // traverse children
            if (!eventName && stateNode.states && stateNode.states.length > 0) {
                const childStateNode = stateNode.states[0];
                state.path = childStateNode.path;
                return this.transition(state, undefined, transitionCount + 1);
            }
            if (stateNode.events) {
                const events = stateNode.events.filter(event => 
                // process the specific transition or if not provided then perform transient events
                eventName ? event.name === eventName : event.isTransient);
                for (const event of events) {
                    if (event.transitions.length > 0) {
                        // TODO: handle more than one transitions
                        const transition = event.transitions[0];
                        // check if transition conditions (guards) exists
                        let isPassGuards = true;
                        if (transition.conditions) {
                            for (const condition of transition.conditions) {
                                isPassGuards = yield this.runGuard(state, condition);
                                if (!isPassGuards) {
                                    break;
                                }
                            }
                        }
                        if (isPassGuards) {
                            const destinationStateNode = this.workflow.getStateNodeRelativeTo(stateNode, transition.target);
                            if (destinationStateNode) {
                                yield this.runAction(state, stateNode.onExit);
                                state.path = destinationStateNode.path;
                                return this.transition(state, undefined, transitionCount + 1);
                            }
                            else {
                                console.error(`Did not find destination state node for transition: ${transition.target}`);
                            }
                            break;
                        }
                    }
                }
            }
            return state;
        });
    }
    runGuardSync(state, condition) {
        var _a, _b;
        const guardFunction = (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.guards) === null || _b === void 0 ? void 0 : _b[condition.type];
        if (guardFunction) {
            return guardFunction(state, condition.params);
        }
        else {
            console.error(`No guard found for: ${condition.type}`);
        }
    }
    runGuard(state, condition) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const guardFunction = (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.guards) === null || _b === void 0 ? void 0 : _b[condition.type];
            if (guardFunction) {
                return guardFunction(state, condition.params);
            }
            else {
                console.error(`No guard found for: ${condition.type}`);
                return;
            }
        });
    }
    runAction(state, action) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!action) {
                return;
            }
            const actionFunction = (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.actions) === null || _b === void 0 ? void 0 : _b[action.type];
            if (actionFunction) {
                return actionFunction(state, action.params);
            }
            else {
                console.error(`No action found for: ${action.type}`);
                return;
            }
        });
    }
    invokeService(state, invoke) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!invoke || (Array.isArray(invoke) && invoke.length === 0)) {
                return;
            }
            // TODO: handle onDone and onError logic
            invoke = Array.isArray(invoke) ? invoke : [invoke];
            // execute all invoke logic one by one
            for (const i of invoke) {
                const serviceFunction = (_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.services) === null || _b === void 0 ? void 0 : _b[i.src];
                if (typeof serviceFunction === 'function') {
                    yield serviceFunction(state, i);
                }
                else {
                    console.error(`No service found for: ${i.src}`);
                }
            }
        });
    }
}
exports.WorkflowMachine = WorkflowMachine;
//# sourceMappingURL=workflow-machine.js.map